import React from "react";
import { List } from "../modules/LedgerTransactions";

export function LedgerTransactionsPage(props) {
  return <List {...props} />;
}
